import { React, useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { useHistory, useLocation } from "react-router-dom";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoaderScreen } from "../../components/LoaderScreen";
import Swal from "sweetalert2";
import request from "../../../Helpers/API";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { DetalleClientesCard } from "../../CreditoyCobranza/GestionCobranza/Components/DetalleClientesCard";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import WebAssetIcon from '@mui/icons-material/WebAsset';

export const DetalleClientesScreen = () => {
    const history = useHistory();
    const { state } = useLocation();
    const [convenios, setConvenios] = useState([]);
    const [conveniosCard, setConveniosCard] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [openModalContacto, setOpenModalContacto] = useState(false);
    const [openModalMedioContacto, setOpenModalMedioContacto] = useState(false);
    const [modalDescarga, setModalDescarga] = useState(false);
    const [cardSelected, setCardSelected] = useState(1);
    const [facturasSeleccionadas, setFacturasSeleccionadas] = useState([]);
    const [contactos, setContactos] = useState([]);

    const [sumaFacturas, setSumaFacturas] = useState({
        saldo: 0,
        moratorios: 0,
        pactados: 0,
        total: 0,
    });

    const [folio, setFolio] = useState("");
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const handleOpenModal = () => {
        setOpenModal(true);
        // setFolio(folio)
    };

    const handleOpenModalContacto = () => {
        setOpenModalContacto(true);
        // setFolio(folio)
    };

    const handleOpenModalMedioContacto = () => {
        if (facturasSeleccionadas.length === 0) {
            Swal.fire({
                title: "CONVENIO DE PAGO",
                text: "Debes seleccionar al menos una factura.",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return;
        }
        setOpenModalMedioContacto(true);
        // setFolio(folio)
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const handleCloseModalContacto = () => {
        setOpenModalContacto(false);
    };

    const handleCloseModalMedioContacto = () => {
        setOpenModalMedioContacto(false);
    };

    //   const abrirModalDescarga = (folio) => {
    //     setModalDescarga(true);
    //     setFolio(folio)
    //   };

    //   const cerrarModalDescarga = () => {
    //     setModalDescarga(false);
    //   };

    const onImprimirEstadoCuenta = (idcliente) => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(`FacturasEstadoCuenta/ReportePDF?idcliente=${idcliente}`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });

                const linkSource = `data:application/pdf;base64, ${result.documento}`;
                const downloadLink = document.createElement("a");
                const fileName = `${result.nombredocumento}.${result.extension}`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("Clientes", JSON.stringify(error), "error");
            });
    };

    useEffect(() => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(
                `ObtenerConveniosClienteGestionar/Convenios?idcliente=${Number(
                    state.idcliente
                )}&card=1`
            )
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setConvenios(result);
                setConveniosCard(result);
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("CONVENIO PAGO", JSON.stringify(error), "error");
            });
    }, []);

    useEffect(() => {
        if (state.idcliente) {
            request
                .get(`ObtenerDatosContactoCliente/DatosContacto?idcliente=${state.idcliente}`)
                .then((result) => {
                    setContactos(result);
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    Swal.fire("CONVENIO DE PAGO", JSON.stringify(error), "error");
                });
        }
    }, [openModalContacto]);

    useEffect(() => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(
                `ObtenerConveniosClienteGestionar/Convenios?idcliente=${Number(
                    state.idcliente
                )}&card=1`
            )
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setConvenios(result);
                setConveniosCard(result);
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("CONVENIO PAGO", JSON.stringify(error), "error");
            });
    }, []);

    const onExecuteCards = (idcliente, card) => {
        return new Promise((resolve, reject) => {
            setLoader({ ...loader, mostrar: true });
            request
                .get(
                    `ObtenerConveniosClienteGestionar/Convenios?idcliente=${Number(
                        idcliente
                    )}&card=${card}`
                )
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    setConvenios(result);
                    setFacturasSeleccionadas([]);
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    Swal.fire("CONVENIO PAGO", JSON.stringify(error), "error");
                });
        });
    };

    const handleCheckboxChange = (isChecked, idfactura, documento, fecha, vencimiento, descripcion, diasvencido, importefactura, importepagado, saldo, interespactado, interesmoratorio, total, tasa, serie_fiscal, folio_fiscal) => {
        if (!isChecked) {
            // Eliminar el objeto donde seleccionada es false
            setFacturasSeleccionadas((prevFacturas) =>
                prevFacturas.filter((facturas) => facturas.idfactura !== idfactura)
            );
        } else {
            // Actualizar o agregar el objeto en el array
            const existingPermissionIndex = facturasSeleccionadas.findIndex(
                (facturas) => facturas.idfactura === idfactura
            );

            if (existingPermissionIndex !== -1) {
                setFacturasSeleccionadas((prevFacturas) => [
                    ...prevFacturas.slice(0, existingPermissionIndex),
                    { ...prevFacturas[existingPermissionIndex], seleccionada: true },
                    ...prevFacturas.slice(existingPermissionIndex + 1)
                ]);
            } else {
                // console.log(tasa)
                if (tasa === 0|| tasa === null|| tasa === undefined) {
                    Swal.fire({
                        title: "CONVENIO DE PAGO",
                        text: "Las facturas seleccionadas deben tener una tasa definida.",
                        icon: "warning",
                        customClass: {
                            container: "mi-superpoop",
                        },
                    });
                }
                else {
                    setFacturasSeleccionadas((prevFacturas) => [
                        ...prevFacturas,
                        { idfactura, idcliente: state.idcliente, documento, descripcion, fecha: fecha, vencimiento: vencimiento, diasvencido, importefactura, importepagado, saldo, interesmoratorio, interespactado, total, tasa, serie: serie_fiscal + " " + folio_fiscal, seleccionada: true },
                    ]);
                }
            }
        }
    };

    // console.log(facturasSeleccionadas)

    useEffect(() => {
        const sumaTotal = facturasSeleccionadas.reduce(
            (total, factura) => total + factura.total,
            0
        );
        const sumaMoratorio = facturasSeleccionadas.reduce(
            (total, factura) => total + factura.interesmoratorio,
            0
        );
        const sumaPactado = facturasSeleccionadas.reduce(
            (total, factura) => total + factura.interespactado,
            0
        );
        const sumaSaldo = facturasSeleccionadas.reduce(
            (total, factura) => total + factura.saldo,
            0
        );

        setSumaFacturas({
            ...sumaFacturas,
            saldo: sumaSaldo,
            moratorios: sumaMoratorio,
            pactados: sumaPactado,
            total: sumaTotal,
        });
    }, [facturasSeleccionadas]);

    const totalConveniosEncontrados = conveniosCard.length;
    const prestamonumero = conveniosCard.filter(
        (convenio) => convenio.tipo === "PC"
    );
    const totalPrestamo = prestamonumero.length;
    const operacionnumero = conveniosCard.filter(
        (convenio) => convenio.tipo === "Operacion"
    );
    const totalOperacion = operacionnumero.length;
    const revolventenumero = conveniosCard.filter(
        (convenio) => convenio.tipo === "Revolvente"
    );
    const totalRevolvente = revolventenumero.length;

    console.log(convenios)
    return (
        <PlantillaScreen
            titulo={`${state.razonsocial}`}
            className={"detalle-clientes-gestionar-main-screen"}
            className_main={1}
        >
            <div className="detalle-clientes-gestionar scroll-4">
                <LoaderScreen loader={loader} />
                <div className="detalle-clientes-gestionar-footer">
                    <div
                        className="detalle-clientes-gestionar-footer-back"
                        onClick={() =>
                            history.push("/Credito/CarteraClientes")
                        }
                    >
                        <ArrowBackIcon /> Regresar
                    </div>
                </div>
                <div className="detalle-clientes-gestionar-header">
                    <div className="detalle-clientes-gestionar-header-title">
                        <FormatListNumberedIcon /> Listado de Facturas Registradas
                    </div>
                </div>
                <div className="detalle-clientes-gestionar-container-total">
                    <div className="detalle-clientes-gestionar-container-resumen">
                        <DetalleClientesCard
                            titulo={"TOTAL"}
                            cantidad={totalConveniosEncontrados}
                            className={
                                "detalle-clientes-gestionar-container-resumen-item-click"
                            }
                            onClick={() => {
                                onExecuteCards(state.idcliente, 1);
                                setCardSelected(1);
                            }}
                            porcentaje={"100%"}
                            activo={cardSelected === 1 ? true : false}
                        />
                        <DetalleClientesCard
                            titulo={"REVOLVENTE"}
                            cantidad={totalRevolvente}
                            className={
                                "detalle-clientes-gestionar-container-resumen-item-click"
                            }
                            onClick={() => {
                                onExecuteCards(state.idcliente, 2);
                                setCardSelected(2);
                            }}
                            porcentaje={`${FormatMoney(
                                (totalRevolvente / totalConveniosEncontrados) * 100,
                                0
                            )}%`}
                            activo={cardSelected === 2 ? true : false}
                        />
                        <DetalleClientesCard
                            titulo={"OPERACIÓN"}
                            cantidad={totalOperacion}
                            className={
                                "detalle-clientes-gestionar-container-resumen-item-click"
                            }
                            onClick={() => {
                                onExecuteCards(state.idcliente, 3);
                                setCardSelected(3);
                            }}
                            porcentaje={`${FormatMoney(
                                (totalOperacion / totalConveniosEncontrados) * 100,
                                0
                            )}%`}
                            activo={cardSelected === 3 ? true : false}
                        />
                        <DetalleClientesCard
                            titulo={"PRESTAMOS"}
                            cantidad={totalPrestamo}
                            className={
                                "detalle-clientes-gestionar-container-resumen-item-click"
                            }
                            onClick={() => {
                                onExecuteCards(state.idcliente, 4);
                                setCardSelected(4);
                            }}
                            porcentaje={`${FormatMoney(
                                (totalPrestamo / totalConveniosEncontrados) * 100,
                                0
                            )}%`}
                            activo={cardSelected === 4 ? true : false}
                        />
                    </div>
                    <div className="detalle-clientes-gestionar-container scroll-4">
                        <div className="info-contacto">
                            {contactos && contactos.length > 0 && (
                                <>
                                    {contactos.slice(0, 3).map(contact => {
                                        if (contact.medio_contacto === 'W ') {
                                            return (
                                                <div className="info-whatsapp green" key={contact.idmedio}>
                                                    <WhatsAppIcon /> {contact.medio}
                                                </div>
                                            );
                                        }
                                        if (contact.medio_contacto === 'T ') {
                                            return (
                                                <div className="info-telefono blue" key={contact.idmedio}>
                                                    <PhoneIcon /> {contact.medio}
                                                </div>
                                            );
                                        }
                                        if (contact.medio_contacto === 'C ') {
                                            return (
                                                <div className="info-correo blue" key={contact.idmedio}>
                                                    <EmailIcon /> {contact.medio}
                                                </div>
                                            );
                                        }
                                        if (contact.medio_contacto === 'P ') {
                                            return (
                                                <div className="info-pagina blue" key={contact.idmedio}>
                                                    <WebAssetIcon /> {contact.medio}
                                                </div>
                                            );
                                        }
                                        return null; 
                                    })}
                                </>
                            )}
                        </div>

                        <table>
                            <thead>
                                <tr>
                                    <th>Serie</th>
                                    <th>
                                        <div>No. Factura</div>
                                    </th>
                                    <th>
                                        <div>Fecha</div>
                                    </th>
                                    <th>
                                        <div>Vencimiento</div>
                                    </th>
                                    <th>
                                        <div>Dias Vencido</div>
                                    </th>
                                    <th>
                                        <div>Tasa</div>
                                    </th>
                                    <th>
                                        <div>Saldo</div>
                                    </th>
                                    <th>
                                        <div>Ints. Pactados</div>
                                    </th>
                                    <th>
                                        <div>Ints. Moratorios</div>
                                    </th>
                                    <th>
                                        <div>Total</div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {convenios.map((con) => (
                                    <tr>
                                        <td className="ta-center">
                                            {con.serie_fiscal + " - " + con.folio_fiscal}
                                        </td>
                                        <td className="ta-center">{con.documento}</td>
                                        <td className="ta-center">{con.fecha}</td>
                                        <td className="ta-center">{con.vencimiento}</td>
                                        <td className="ta-center">
                                            {con.diasvencido < 1 ? "" : con.diasvencido}
                                        </td>
                                        <td className="ta-right">{con.tipo === 'Revolvente' ? con.tasa_moratoria : con.tasa} %</td>
                                        <td className="ta-right">{FormatMoney(con.saldo)}</td>
                                        <td className="ta-right">
                                            {con.interes_pactado === 0
                                                ? "-"
                                                : FormatMoney(con.interes_pactado)}
                                        </td>
                                        <td className="ta-right">
                                            {con.interes_moratorio === 0
                                                ? "-"
                                                : FormatMoney(con.interes_moratorio)}
                                        </td>
                                        <td className="ta-right">{FormatMoney(con.saldo_total)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </PlantillaScreen>
    );
};
